import React from "react";

const LazyImage = ({
  loading = "lazy",
  decoding = "async",
  alt = "",
  ...props
}) => (
  <img loading={loading} decoding={decoding} alt={alt} {...props} />
);

export default LazyImage;
